// src/components/filters/FiltersPanel.vue

<template>
  <v-navigation-drawer v-model="drawer" app  class="mt-9" stateless width="200">
    <v-layout row wrap class="mt-10 ma-0 pa-2">
      <v-flex xs12>
        <!-- Category Filter -->
        <FilterDropdown
          label="Select Category"
          :items="categoryOptions"
          v-model="selectedCategory"
          filter-type="category"
          @filter-change="handleFilterChange"
        />

        <!-- Owner Filter -->
        <FilterDropdown
          label="Select Type"
          :items="ownerOptions"
          v-model="selectedOwner"
          filter-type="owner"
          @filter-change="handleFilterChange"
        />

        <!-- Zone Filter -->
        <FilterDropdown
          label="Select Sector"
          :items="zoneOptions"
          v-model="selectedZone"
          filter-type="zone"
          @filter-change="handleFilterChange"
        />

        <!-- Dimensions Filter -->
        <!-- <FilterDropdown
          label="Select Dimensions"
          :items="dimensionOptions"
          v-model="selectedDimension"
          filter-type="dimensions"
          @filter-change="handleFilterChange"
        /> -->

        

        <!-- Status Filter -->
        <FilterDropdown
          label="Select Status"
          :items="soldStatusOptions"
          v-model="selectedStatus"
          filter-type="soldStatus"
          @filter-change="handleFilterChange"
        />

        <v-divider class="my-12"></v-divider>

         <!-- Logo Section -->
         <v-flex xs12>
            <v-layout row align-center justify-space-between class="mx-0" style="margin-bottom: 20px;">
                <span  style="margin-left: 5px; color:'#03396c'; font-size: 15px;">Powered By:</span>
            </v-layout>
            <v-layout row align-center justify-center class="mx-0" style="margin-bottom: 20px;">
                <img src="img/logos/logo.png" height="50px" />
            </v-layout>
            <!-- <v-divider class="my-30"></v-divider> -->
        </v-flex>


        <!-- Progress Section -->
        <!-- <ProgressSection /> -->
      </v-flex>

     
    </v-layout>
  </v-navigation-drawer>
</template>

<script>
import { mapGetters } from 'vuex';
import FilterDropdown from './FilterDropdown.vue';
import ProgressSection from './ProgressSection.vue';

export default {
  name: 'FiltersPanel',

  components: {
    FilterDropdown,
    ProgressSection
  },

  props: {
    value: {
      type: Boolean,
      default: true
    }
  },

  data() {
    return {
      selectedCategory: null,
      selectedZone: null,
      selectedDimension: null,
      selectedOwner: null,
      selectedStatus: null
    };
  },

  computed: {
    ...mapGetters('geojson', [
      'categoryOptions',
      'zoneOptions',
      'dimensionOptions',
      'ownerOptions',
      'soldStatusOptions'
    ]),

    drawer: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      }
    }
  },

  methods: {
    handleFilterChange({ filterType, value }) {
      this.$store.dispatch('geojson/updateFilter', { filterType, value });
    }
  }
}
</script>